/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Full meeting snapshot for the detail dialog (Summary / Tasks / Transcript).
 * @export
 * @interface TeamMeetingDetail
 */
export interface TeamMeetingDetail {
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  teamMemberMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamMeetingDetail
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  jamieUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  transcript?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  notes?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  participantsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  actionItemsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingDetail
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the TeamMeetingDetail interface.
 */
export function instanceOfTeamMeetingDetail(
  value: object,
): value is TeamMeetingDetail {
  if (
    !("teamMemberMeetingId" in value) ||
    value["teamMemberMeetingId"] === undefined
  )
    return false;
  return true;
}

export function TeamMeetingDetailFromJSON(json: any): TeamMeetingDetail {
  return TeamMeetingDetailFromJSONTyped(json, false);
}

export function TeamMeetingDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMeetingDetail {
  if (json == null) {
    return json;
  }
  return {
    teamMemberMeetingId: json["teamMemberMeetingId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    jamieUrl: json["jamieUrl"] == null ? undefined : json["jamieUrl"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    transcript: json["transcript"] == null ? undefined : json["transcript"],
    notes: json["notes"] == null ? undefined : json["notes"],
    participantsJson:
      json["participantsJson"] == null ? undefined : json["participantsJson"],
    actionItemsJson:
      json["actionItemsJson"] == null ? undefined : json["actionItemsJson"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function TeamMeetingDetailToJSON(json: any): TeamMeetingDetail {
  return TeamMeetingDetailToJSONTyped(json, false);
}

export function TeamMeetingDetailToJSONTyped(
  value?: TeamMeetingDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberMeetingId: value["teamMemberMeetingId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    jamieUrl: value["jamieUrl"],
    summaryMarkdown: value["summaryMarkdown"],
    transcript: value["transcript"],
    notes: value["notes"],
    participantsJson: value["participantsJson"],
    actionItemsJson: value["actionItemsJson"],
    createdBy: value["createdBy"],
  };
}
